import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-266b7856"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "app__gallery flex__center" }
const _hoisted_2 = { class: "app__gallery-content" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h1", { class: "h-text" }, "Photo Gallery", -1))
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "p-text" }, "Here are the latest photos from our project.", -1))
const _hoisted_5 = { class: "app__gallery-images" }
const _hoisted_6 = ["onClick"]
const _hoisted_7 = ["src"]
const _hoisted_8 = { class: "gallery__image-description mx-12" }
const _hoisted_9 = { class: "app__gallery-images_arrows" }

import { ref } from "vue";
import media_images from "@/shared/media_images";
import ImagePopup from "@/components/ImagePopup.vue";


export default /*#__PURE__*/_defineComponent({
  __name: 'PhotoCarroussel',
  setup(__props) {

const scrollRef = ref<HTMLElement | null>(null);
const popupVisible = ref(false);
const selectedImage = ref("");
const selectedDescription = ref("");

const scroll = (direction: string) => {
  if (scrollRef.value) {
    if (direction === "left") {
      scrollRef.value.scrollLeft -= 301;
    } else {
      scrollRef.value.scrollLeft += 301;
    }
  }
};

const openPopup = (image: any, description: any) => {
  selectedImage.value = image;
  selectedDescription.value = description;
  popupVisible.value = true;
};

const closePopup = () => {
  popupVisible.value = false;
};

return (_ctx: any,_cache: any) => {
  const _component_router_link = _resolveComponent("router-link")!
  const _component_v_icon = _resolveComponent("v-icon")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _hoisted_3,
        _hoisted_4,
        _createVNode(_component_router_link, {
          type: "button",
          class: "custom__button",
          to: "/media"
        }, {
          default: _withCtx(() => [
            _createTextVNode(" View More ")
          ]),
          _: 1
        })
      ]),
      _createElementVNode("div", _hoisted_5, [
        _createElementVNode("div", {
          class: "app__gallery-images_container",
          ref_key: "scrollRef",
          ref: scrollRef
        }, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(media_images), (image, index) => {
            return (_openBlock(), _createElementBlock("div", {
              class: "app__gallery-images_card flex__center",
              key: 'gallery_image-' + (index + 1),
              onClick: ($event: any) => (openPopup(image.photo, image.description))
            }, [
              _createElementVNode("img", {
                src: image.photo,
                alt: "gallery_image"
              }, null, 8, _hoisted_7),
              _createElementVNode("p", _hoisted_8, _toDisplayString(image.description), 1)
            ], 8, _hoisted_6))
          }), 128))
        ], 512),
        _createElementVNode("div", _hoisted_9, [
          _createVNode(_component_v_icon, {
            class: "gallery__arrow-icon",
            onClick: _cache[0] || (_cache[0] = ($event: any) => (scroll('left')))
          }, {
            default: _withCtx(() => [
              _createTextVNode("mdi-arrow-left-circle")
            ]),
            _: 1
          }),
          _createVNode(_component_v_icon, {
            class: "gallery__arrow-icon",
            onClick: _cache[1] || (_cache[1] = ($event: any) => (scroll('right')))
          }, {
            default: _withCtx(() => [
              _createTextVNode("mdi-arrow-right-circle")
            ]),
            _: 1
          })
        ])
      ])
    ]),
    _createVNode(ImagePopup, {
      showPopup: popupVisible.value,
      selectedImage: selectedImage.value,
      selectedDescription: selectedDescription.value,
      onClosePopup: closePopup
    }, null, 8, ["showPopup", "selectedImage", "selectedDescription"])
  ], 64))
}
}

})